import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { ChallengesProvider as Provider, platformProviderValue } from '@shapeable/ui';

const CHALLENGES_QUERY = graphql`
query PlatformAllChallengesQuery {
  platform { allChallenges {
    __typename _schema { label pluralLabel }
    taxonomyLabel
    id path slug name dataSetId
    openGraph { description { text } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
    icon {
      id
      name
      component
    }
    color {
      id
      name
      value
    }
  } }
}

`;

export const ChallengesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(CHALLENGES_QUERY), 'allChallenges' ) }>{children}</Provider>;
};